// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact_container_contact__sE6TN {
  width: 95%;
  display: flex;
  flex: 1 1; 
  flex-wrap: nowrap;
   flex-direction: row;
  align-items: center;
  justify-content: space-around;
  align-content: center;
  margin-top: 1%;
}

.contact_contact_info__SF3c4{
 display: flex;
  flex:2 1; 
  flex-direction: row;
  align-items: center;
  margin-left: 5%;
  justify-content: flex-end;
  margin-left:auto;

}
.contact_hsrc__logo__MkKAp {
  
  display: flex;
  vertical-align: bottom;
   width: auto;
  height: 90px;
  margin-left: 5%;
}

  
.contact_contact_logo__LCGf0{
   display: flex;
  flex:1 1; 
  flex-direction: row;
  align-items: center;
  margin-right: 5%;
  justify-content: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/components/Contact/contact.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,SAAO;EACP,iBAAiB;GAChB,mBAAmB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;CACC,aAAa;EACZ,QAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;;AAElB;AACA;;EAEE,aAAa;EACb,sBAAsB;GACrB,WAAW;EACZ,YAAY;EACZ,eAAe;AACjB;;;AAGA;GACG,aAAa;EACd,QAAM;EACN,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B","sourcesContent":[".container_contact {\r\n  width: 95%;\r\n  display: flex;\r\n  flex: 1; \r\n  flex-wrap: nowrap;\r\n   flex-direction: row;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n  align-content: center;\r\n  margin-top: 1%;\r\n}\r\n\r\n.contact_info{\r\n display: flex;\r\n  flex:2 ; \r\n  flex-direction: row;\r\n  align-items: center;\r\n  margin-left: 5%;\r\n  justify-content: flex-end;\r\n  margin-left:auto;\r\n\r\n}\r\n.hsrc__logo {\r\n  \r\n  display: flex;\r\n  vertical-align: bottom;\r\n   width: auto;\r\n  height: 90px;\r\n  margin-left: 5%;\r\n}\r\n\r\n  \r\n.contact_logo{\r\n   display: flex;\r\n  flex:1; \r\n  flex-direction: row;\r\n  align-items: center;\r\n  margin-right: 5%;\r\n  justify-content: flex-start;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_contact": `contact_container_contact__sE6TN`,
	"contact_info": `contact_contact_info__SF3c4`,
	"hsrc__logo": `contact_hsrc__logo__MkKAp`,
	"contact_logo": `contact_contact_logo__LCGf0`
};
export default ___CSS_LOADER_EXPORT___;
